import TemplateModal from "./template-modal";

export default TemplateModal;